"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageLevelHeadingType = void 0;
var PageLevelHeadingType;
(function (PageLevelHeadingType) {
    PageLevelHeadingType["HEADING_WITH_ICON"] = "HEADING_WITH_ICON";
    PageLevelHeadingType["HEADING_MODAL"] = "HEADING_MODAL";
})(PageLevelHeadingType = exports.PageLevelHeadingType || (exports.PageLevelHeadingType = {}));
//# sourceMappingURL=PageLevelHeadingProps.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/common/PageLevelHeading/PageLevelHeadingProps.js
// module id = 159
// module chunks = 8